import React, { useState } from 'react';
import MetaTitle from '../components/MetaTitle';
import { Link } from 'react-router-dom';
import "../assete/css/contact.css";
import Header from './Header';
import new_mark_pic from "../assete/contact/Digital20Marketing20Careers.jpg";
import Footer from './Footer';
import contsct_pic from "../assete/bannerimage/contact-us.jpg";
import { ContactusApi } from '../service/Api';
import Scrolltop from './Scrolltop';
 import Whatsapp from './Whatsapp';
 import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const [formData, setFormData] = useState({
    user_name: '',
    user_phone: '',
    user_email: '',
    service_type: '',
    user_message: '',
  });
  
  const [errorMessage, setErrorMessage] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);



  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };
  
   const handleCaptchaChange = (value) => {
    setCaptchaValue(value); // ✅ Store captcha token
  };
  

  const handleSubmit = async () => {
    let errors = {};
  
    // Validation for all fields
    if (!/^[A-Za-z\s]+$/.test(formData.user_name.trim())) {
      errors.user_name = 'Enter your Name';
    }
  
    if (!/^[0-9]{10}$/.test(formData.user_phone.trim())) {
      errors.user_phone = 'Phone number must be 10 digits.';
    }
  
    if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.user_email.trim())) {
      errors.user_email = 'Enter a valid email address.';
    }
  
    if (formData.service_type.trim() === '' || formData.service_type === 'select*') {
      errors.service_type = 'Please select a service type.';
    }
  
    if (formData.user_message.trim() === '') {
      errors.user_message = 'Message cannot be empty.';
    }
    if (!captchaValue) {
      errors.captcha = 'Please verify the CAPTCHA before submitting.';
    }
  
    // If errors exist, display them and stop submission
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setTimeout(() => {
        setErrorMessage(''); // Clear error messages after 5 seconds
      }, 2000);
      return;
    }
    
  
   try {
      setErrorMessage({});

      // ✅ Send CAPTCHA token along with form data
      const payload = {
        ...formData,
        captchaValue
      };
      const response = await ContactusApi(payload);
      console.log('Form data saved:', response.data);
  
      setSuccessMessage(' submitted successfully!');
      setFormData({
        user_name: '',
        user_phone: '',
        user_email: '',
        service_type: '',
        user_message: '',
         captchaValue:'',
      });
   setCaptchaValue(null);

      setTimeout(() => {
        setSuccessMessage('');
      }, 2000);
    } catch (error) {
      console.error('Error saving form data:', error);
      setErrorMessage('Failed to submit the form. Please try again.');
    }
  };
  

    
  return (
   <>

<MetaTitle title={"Contact Us | "} description="Find the best place to guide your research works at an affordable price. Visit Sea Sense Software Pvt. Ltd. for PhD guidance."
        keywords="PhD guidance in Marthandam |
PhD assistance in marthandam | PhD Thesis writing in marthandam | PhD paper writing in marthandam | Research paper writing in marthandam |
Research assistance in Marthandam | Research guidance in marthandam | Mat lab training in marthandam | PhD addmission | PhD Scholarships |
Research topics for PhD scholar | Research topics | Recent research topics | PhD guidance in kanyakumari |
PhD assistance in kanyakumari | PhD Thesis writing in kanyakumari | PhD paper writing in kanyakumari | Research paper writing in kanyakumari |
Research assistance in kanyakumari | Research guidance in kanyakumari | Mat lab training in kanyakumari | PhD guidance in tamilnadu |
PhD assistance in tamilnadu | PhD Thesis writing in tamilnadu | PhD paper writing in tamilnadu | Research paper writing in tamilnadu |
Research assistance in tamilnadu | Research guidance in tamilnadu | Mat lab training in tamilnadu | PhD guidance in nagercoil |
PhD assistance in nagercoil | PhD Thesis writing in nagercoil | PhD paper writing in nagercoil | Research paper writing in nagercoil |
Research assistance in nagercoil | Research guidance in nagercoil | Mat lab training in nagercoil | PhD guidance in trivandrum |
PhD assistance in trivandrum | PhD Thesis writing in trivandrum | PhD paper writing in trivandrum | Research paper writing in trivandrum |
Research assistance in trivandrum | Research guidance in trivandrum | Mat lab training in trivandrum | PhD guidance in alleppey |
PhD assistance in alleppey | PhD Thesis writing in alleppey | PhD paper writing in alleppey | Research paper writing in alleppey |
Research assistance in alleppey | Research guidance in alleppey | Mat lab training in alleppey | PhD guidance in chennai |
PhD assistance in chennai | PhD Thesis writing in chennai | PhD paper writing in chennai | Research paper writing in chennai |
Research assistance in chennai | Research guidance in chennai | Mat lab training in chennai | PhD guidance in madurai |
PhD assistance in madurai | PhD Thesis writing in madurai | PhD paper writing in madurai | Research paper writing in madurai |
Research assistance in madurai | Research guidance in madurai | Mat lab training in madurai | PhD guidance in trichy |
PhD assistance in trichy | PhD Thesis writing in trichy | PhD paper writing in trichy | Research paper writing in trichy |
Research assistance in trichy | Research guidance in trichy | Mat lab training in trichy | PhD guidance in tirunelveli |
PhD assistance in tirunelveli | PhD Thesis writing in tirunelveli | PhD paper writing in tirunelveli | Research paper writing in tirunelveli |
Research assistance in tirunelveli | Research guidance in tirunelveli | Mat lab training in tirunelveli | PhD guidance in singapore |
PhD assistance in singapore | PhD Thesis writing in singapore | PhD paper writing in singapore | Research paper writing in singapore |
Research assistance in singapore | Research guidance in singapore | Mat lab training in singapore | PhD guidance in india |
PhD assistance in india | PhD Thesis writing in india | PhD paper writing in india | Research paper writing in india |
Research assistance in india | Research guidance in india | Mat lab training in india | PhD guidance in kollam |
PhD assistance in kollam | PhD Thesis writing in kollam | PhD paper writing in kollam | Research paper writing in kollam |
Research assistance in kollam | Research guidance in kollam | Mat lab training in kollam | PhD guidance in cochin |
PhD assistance in cochin | PhD Thesis writing in cochin | PhD paper writing in cochin | Research paper writing in cochin |
Research assistance in cochin | Research guidance in cochin | Mat lab training in cochin | PhD guidance in ernakulam |
PhD assistance in ernakulam | PhD Thesis writing in ernakulam | PhD paper writing in ernakulam | Research paper writing in ernakulam |
Research assistance in ernakulam | Research guidance in ernakulam | Mat lab training in ernakulam |"/>
   <Header/>
   <div className='seasense_web_contact_main'>
    <img src={contsct_pic} alt=""/>
   
  
        <div className="about_content" >
    <h1 data-aos="zoom-in" data-aos-duration="2000">Contact Us </h1>
    </div>
         </div>
   

   <div className='seasense_contct_main_div'>
    <div className='seasense_conts_div_1'>
           <div className='seasense_conts_div_2'>
            <div className='conts_div_2'>
                  <h2><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM16 19.3955L20 17.6812V5.03308L16 6.74736V19.3955ZM14 19.2639V6.73607L10 4.73607V17.2639L14 19.2639ZM8 17.2526V4.60451L4 6.31879V18.9669L8 17.2526Z"></path></svg></h2>
            </div>
            <div className='seasense_conts_offz_name'>
              <h1>Sea Sense Interdisciplinary Research and IT Solutions (OPC) Pvt. Ltd.</h1>
              <p>JJ Arcade, Second Floor, Near New Bus Stand</p>
              <p>Marthandam, Kanyakumari District</p>
              <p>TamilNadu, India - 629165</p>

            </div>
            </div>
            <br></br>
            <div className='seasense_line_new'></div>
            <div className='seasense_conts_div_2'>
            <div className='conts_div_2'>
              <h2><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"></path></svg></h2>
            </div>
            <div className='seasense_conts_offz_name'>
              {/* <h2>Phone :</h2> */}
              <p><Link to="tel:+91-8526700700">+91-85 26 700 700</Link></p>
            </div>
           </div>
          
           <br></br>
           <div className='seasense_line_new'></div>
            <div className='seasense_conts_div_2'>
            <div className='conts_div_2'>
              <h2><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM2 4C2 3.44772 2.44772 3 3 3H14V5H4.5052L12 11.662L16.3981 7.75259L17.7269 9.24741L12 14.338L4 7.22684V19H20V11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4Z"></path></svg></h2>
            </div>
            <div className='seasense_conts_offz_name'>
              {/* <h2>Email :</h2> */}
              <p><Link to="mailto:info@seasensesoftwares.com">info@seasensesoftwares.com</Link></p>
              <p><Link to="mailto:projectdelivery@seasensesoftwares.com">projectdelivery@seasensesoftwares.com</Link></p>
            </div>
      </div>
    </div>
    <div className='seasense_contsct_full_form'>
            <div className='seasense_contct_hed'>
                <h2>Have Any Questions? Let's Answer Them</h2>
                <h1>SEASENSE RESEARCH </h1>
            </div>
          
            <div className='seasense_contsct_form_full_input'>
                <input type="text" placeholder='Name*' id="user_name" value={formData.user_name} onChange={handleChange} autoComplete='off'/>
                {errorMessage.user_name && <div className="error-message" style={{ color: 'red',fontSize:"10px" }}>{errorMessage.user_name}</div>}
                <input type="text" placeholder='Phone*' id="user_phone" value={formData.user_phone} onChange={handleChange} />
                {errorMessage.user_phone && <div className="error-message" style={{ color: 'red',fontSize:"10px" }}>{errorMessage.user_phone}</div>}
                <input type="Email" placeholder='Email*' id="user_email" value={formData.user_email} onChange={handleChange} autoComplete='off'/>
                {errorMessage.user_email && <div className="error-message" style={{ color: 'red',fontSize:"10px" }}>{errorMessage.user_email}</div>}
                <select  id="service_type" onChange={handleChange} autoComplete='off'>
                <option   id="service_type" value={formData.service_type} autoComplete='off'>select*</option>
                                <option value="Research Proposal">Research Proposal</option>
                                <option value="Research Paper">Research Paper</option>
                                <option value="Implementation">Implementation</option>
                                <option value="Publication Assistance">Publication Assistance</option>
                                <option value="Polishing">Polishing</option>
                                <option value="Web Hosting">Web Hosting</option>
                                <option value="Email Service">Email Service</option>
                                <option value="SMS Service">SMS Service</option>
                                <option value="Student Management">Student Management</option>
                                <option value="Employee Payroll">Employee Payroll</option>
                                <option value="other">Other</option>
                </select>
                {errorMessage.service_type && <div className="error-message" style={{ color: 'red',fontSize:"10px" }}>{errorMessage.service_type}</div>}
                <textarea type="text" placeholder='Message*' id='user_message' value={formData.user_message} onChange={handleChange}></textarea>
                {errorMessage.user_message && <div className="error-message" style={{ color: 'red',fontSize:"10px" }}>{errorMessage.user_message}</div>}
            </div>
              <div style={{ margin: "15px 0" }}>
         <ReCAPTCHA
            sitekey="6LeeG7crAAAAABxiB3YMx4Gidvu_IgCzrASGWOLy"  // :white_check_mark: Replace with your Google reCAPTCHA site key
            onChange={handleCaptchaChange}
            onExpired={() => {
          setCaptchaValue(null);
          alert("Captcha expired, please check again."); }}/>
          {errorMessage.captcha && <div className="error-message" style={{ color: 'red', fontSize: "10px" }}>{errorMessage.captcha}</div>}
        </div>
            <div className='seasense_contact_sub_bts'>
                <button onClick={handleSubmit}>Submit</button>
                {successMessage && <div className="success-message" style={{ color: 'green' }}>{successMessage}</div>}
            </div>
        </div>
   </div>
<div className='seasense_mark_new_design'>
  <div className='marking_pic_add'>
    <div className='marking_main_div'>
      <div className='mark_cont_add'>
        <h2>Marketing Office :</h2>
        <h1>SEASENSE TECHNOLOGIES</h1>
        <p>Third Floor, Pulimootil Trade Center</p>
        <p>Alleppey, Kerala, INDIA - 688001</p>
        <div className='mark_num_add'>
          <h3>Mobile :</h3>
          <p><Link to="tel:+91-7402616152">+91-7402616152</Link></p>
          <p><Link to="tel:+91-7402616158">+91-7402616158</Link></p>
        </div>
      </div>
      <div className='mark_new_pic_add'>
        <img src={new_mark_pic} alt=""/>
      </div>
    </div>
  </div>
</div>
    <div className='sale_team_new_div'>
      <div className='sale_team_new_div_1'>
          <div className='tema_conts_add'>
            <h2>Sales Team</h2>
            <h1>Phone Number (Toll Free)</h1>
            <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:"20px"}}><path d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"></path></svg><Link to="tel:+91-18005726426">1800 5726 426</Link>  (For All Services)</p>
            <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:"20px"}}><path d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"></path></svg><Link to="tel:+91-7402616152">+91-7402616152</Link>  (For All Services)</p>
            <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:"20px"}}><path d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"></path></svg><Link to="tel:+91-7402616158">+91-7402616158</Link>  (For All Services)</p>
            <h2>Email</h2>
            <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"style={{width:"20px"}}><path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.23792L12.0718 14.338L4 7.21594V19H20V7.23792ZM4.51146 5L12.0619 11.662L19.501 5H4.51146Z"></path></svg><Link to="mailto:info@seasensesoftwares.com"> info@seasensesoftwares.com</Link></p>
          </div>
          <div className='tema_conts_add'>
            <h2>Support Team</h2>
            <h1>Support CenterPhone</h1>
            <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" ><path d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"></path></svg><Link to="tel:18005726426">1800 5726 426</Link>  (9.30 AM - 7 PM : IST)</p>
          
            <h2>Email</h2>
            <p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.23792L12.0718 14.338L4 7.21594V19H20V7.23792ZM4.51146 5L12.0619 11.662L19.501 5H4.51146Z"></path></svg><Link to="mailto:projectdelivery@seasensesoftwares.com"> projectdelivery@seasensesoftwares.com</Link> </p>
          </div>
      </div>
    </div>
  
 <Whatsapp/> 
   <Scrolltop/>
   <Footer/>
   </>
  )
}

export default Contact